var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3883 10.0075L2.37426 18.0216L0.371094 16.0184L7.38359 9.0059L0.371094 1.9934L2.37426 -0.00976562L10.3883 8.00432C10.6539 8.26998 10.8031 8.63025 10.8031 9.0059C10.8031 9.38155 10.6539 9.74182 10.3883 10.0075Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarRightArrow);
export default __webpack_public_path__ + "static/media/navbar-right-arrow.f36249ec5e0ff87be9171af6ce587c64.svg";
export { ForwardRef as ReactComponent };